// extracted by mini-css-extract-plugin
export default {"addCar":"style_addCar__AS2Er"};